/* Ferlant tema betiği. Bağımlılık yok. */
(() => {
  'use strict';

  const F = window.Ferlant || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Yardımcılar ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || F.moneyFormat || '{{amount}} TL';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (number, precision, thousands = '.', decimal = ',') => {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };
    const match = format.match(placeholder);
    if (!match) return String(cents / 100);
    let value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(placeholder, value);
  }
  F.formatMoney = formatMoney;

  const debounce = (fn, wait = 250) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(null, args), wait); };
  };

  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }
  F.toast = toast;

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Çekmeceler ---------- */
  const focusableSel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let activeDrawer = null;
  let lastFocus = null;

  function openDrawer(id, opener) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, false);
    lastFocus = opener || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.documentElement.classList.add('has-drawer');
      const target = $('[data-autofocus]', drawer) || $(focusableSel, $('.drawer__panel', drawer) || drawer);
      if (target) setTimeout(() => target.focus({ preventScroll: true }), 60);
    });
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    activeDrawer = drawer;
    drawer.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  }

  function closeDrawer(drawer = activeDrawer, restoreFocus = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 320);
    if (activeDrawer === drawer) activeDrawer = null;
    drawer.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    if (restoreFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  F.openDrawer = openDrawer;
  F.closeDrawer = closeDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.dataset.openDrawer === 'CartDrawer' && F.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.openDrawer, opener);
      return;
    }
    if (e.target.closest('[data-close-drawer]')) {
      e.preventDefault();
      closeDrawer(e.target.closest('.drawer') || activeDrawer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!activeDrawer) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      const panel = $('.drawer__panel', activeDrawer) || activeDrawer;
      const items = $$(focusableSel, panel).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header: aşağı kaydırınca gizle, yukarıda göster ---------- */
  (() => {
    const header = $('[data-site-header]');
    if (!header || header.dataset.sticky !== 'true') return;
    let lastY = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (!activeDrawer) {
          const hide = y > lastY && y > 240;
          header.classList.toggle('is-hidden', hide);
          document.documentElement.classList.toggle('header-hidden', hide);
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ---------- Sepet ---------- */
  const Cart = {
    sectionIds() {
      const ids = ['cart-drawer'];
      const page = $('[data-cart-page]');
      if (page) ids.push(page.dataset.sectionId);
      return ids;
    },

    async add(items, { open = true, button = null } = {}) {
      if (button) button.classList.add('is-loading');
      try {
        const res = await fetch(`${F.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Ferlant': '1' },
          body: JSON.stringify({ items, sections: this.sectionIds().join(','), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || F.strings.cartError);
        this.renderSections(data.sections);
        this.afterChange(open);
        return data;
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    },

    async addForm(form, { button = null } = {}) {
      const body = new FormData(form);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', window.location.pathname);
      if (button) button.classList.add('is-loading');
      try {
        const res = await fetch(`${F.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', 'X-Ferlant': '1' },
          body
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || F.strings.cartError);
        this.renderSections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        this.afterChange(true);
        return data;
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    },

    async change(line, quantity) {
      const root = $('[data-cart-root]') || document;
      root.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${F.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Ferlant': '1' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds().join(','), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || F.strings.cartError);
        this.renderSections(data.sections);
        this.updateCount(data.item_count);
        document.dispatchEvent(new CustomEvent('cart:changed', { detail: data }));
      } catch (err) {
        toast(err.message || F.strings.cartError);
        this.refresh();
      } finally {
        root.removeAttribute('aria-busy');
      }
    },

    async refresh(open = false) {
      const res = await fetch(`${window.location.pathname}?sections=${this.sectionIds().join(',')}`, { headers: { 'X-Ferlant': '1' } });
      if (!res.ok) return;
      this.renderSections(await res.json());
      if (open) this.afterChange(true);
    },

    renderSections(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = parseHTML(html);
        const fresh = $('[data-section-content]', doc);
        const current = $(`#shopify-section-${id} [data-section-content]`);
        if (fresh && current) current.replaceWith(fresh);
        const countSrc = $('[data-cart-count-source]', doc);
        if (countSrc) this.updateCount(parseInt(countSrc.dataset.cartCountSource, 10) || 0);
      });
    },

    updateCount(count) {
      if (typeof count !== 'number' || isNaN(count)) return;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      $$('[data-cart-count-label]').forEach((el) => {
        el.textContent = el.dataset.template ? el.dataset.template.replace('[count]', count) : count;
      });
    },

    afterChange(open) {
      if (F.cartType === 'drawer' && open && $('#CartDrawer')) {
        openDrawer('CartDrawer');
      } else if (open && F.cartType !== 'drawer' && !$('[data-cart-page]')) {
        window.location.href = F.routes.cart;
      }
    }
  };
  F.cart = Cart;

  // Sepet içindeki etkileşimler (adet, sil, öneri ekle)
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const line = parseInt(qtyBtn.dataset.line, 10);
      const input = $(`[data-cart-qty-input][data-line="${line}"]`);
      const current = input ? parseInt(input.value, 10) || 0 : 0;
      const next = Math.max(0, current + (qtyBtn.dataset.cartQty === 'plus' ? 1 : -1));
      Cart.change(line, next);
      return;
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      Cart.change(parseInt(remove.dataset.line, 10), 0);
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      Cart.add([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], { button: quick })
        .catch((err) => toast(err.message));
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (input) Cart.change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(`${F.routes.cartUpdate}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }
  });

  // Uygulamaların (ör. paket/set uygulamaları) sepete eklemesini yakala ve çekmeceyi güncelle
  ['cart:refresh', 'cart:updated', 'cart:update', 'theme:cart:refresh'].forEach((name) => {
    document.addEventListener(name, () => Cart.refresh(true));
  });
  if (window.fetch && !window.fetch.__ferlant) {
    const nativeFetch = window.fetch.bind(window);
    const wrapped = async (input, init = {}) => {
      const res = await nativeFetch(input, init);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const headers = init && init.headers;
        const ours = headers && (headers['X-Ferlant'] || (headers.get && headers.get('X-Ferlant')));
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (!ours && method === 'POST' && /\/cart\/add/.test(url) && res.ok) {
          setTimeout(() => Cart.refresh(true), 150);
        }
      } catch (_) { /* yok say */ }
      return res;
    };
    wrapped.__ferlant = true;
    window.fetch = wrapped;
  }

  /* ---------- Ürün formu ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || F.cartType !== 'drawer' || e.defaultPrevented) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    const error = $('[data-form-error]', form.closest('[data-product]') || form);
    if (error) error.hidden = true;
    Cart.addForm(form, { button }).catch((err) => {
      if (error) { error.textContent = err.message; error.hidden = false; }
      else toast(err.message);
    });
  });

  /* ---------- Adet seçici ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = $('input', wrap);
    const min = parseInt(input.min || '1', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let value = parseInt(input.value, 10) || min;
    value = btn.dataset.qtyBtn === 'plus' ? Math.min(max, value + 1) : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Varyant seçimi ---------- */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.product = root.closest('[data-product]');
      const json = $('script[type="application/json"][data-variants]', root);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = $('form[data-product-form]', this.product);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.updateUrl = root.dataset.updateUrl === 'true';
      this.optionCount = $$('[data-option-index]', root).length;
      root.addEventListener('change', () => this.onChange());
      this.refreshAvailability();
      if (this.isIncomplete()) this.renderIncomplete();
    }

    isIncomplete() { return this.selectedOptions().some((o) => o === null || o === ''); }

    renderIncomplete() {
      const p = this.product;
      const btns = [...$$('[data-add-button]', p.closest('.shopify-section') || p), $('[data-sticky-add]')].filter(Boolean);
      btns.forEach((b) => {
        const label = $('[data-add-label]', b) || b;
        label.textContent = F.strings.chooseSize;
        b.dataset.incomplete = 'true';
        b.setAttribute('aria-disabled', 'false');
        if (b.type === 'submit') b.disabled = false;
      });
    }

    promptMissing() {
      const missing = $$('[data-option-index]', this.root).find((g) => {
        const radios = $$('input[type="radio"]', g);
        const select = $('select', g);
        return radios.length ? !radios.some((r) => r.checked) : select && !select.value;
      });
      if (!missing) return;
      missing.classList.remove('is-missing');
      void missing.offsetWidth;
      missing.classList.add('is-missing');
      const msg = $('[data-missing-message]', missing);
      if (msg) msg.hidden = false;
      missing.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      const first = $('input, select', missing);
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 350);
    }

    selectedOptions() {
      return $$('[data-option-index]', this.root).map((group) => {
        const checked = $('input:checked', group);
        if (checked) return checked.value;
        const select = $('select', group);
        return select && select.value ? select.value : null;
      });
    }

    findVariant(options) {
      return this.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    onChange() {
      const options = this.selectedOptions();
      this.refreshAvailability();
      $$('[data-option-index]', this.root).forEach((group, i) => {
        const label = $('[data-selected-value]', group);
        if (label && options[i]) label.textContent = options[i];
        if (options[i]) {
          group.classList.remove('is-missing');
          const msg = $('[data-missing-message]', group);
          if (msg) msg.hidden = true;
        }
      });
      if (this.isIncomplete()) { this.renderIncomplete(); return; }
      this.render(this.findVariant(options), options);
    }

    refreshAvailability() {
      const options = this.selectedOptions();
      $$('[data-option-index]', this.root).forEach((group) => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        $$('input[type="radio"]', group).forEach((input) => {
          const test = options.slice();
          test[idx] = input.value;
          const match = this.variants.find((v) => v.available && v.options.every((o, i) => test[i] === null || o === test[i]));
          const exists = this.variants.some((v) => v.options[idx] === input.value && v.available);
          input.classList.toggle('is-unavailable', !match);
          input.dataset.exists = exists ? 'true' : 'false';
        });
        $$('option', group).forEach((opt) => {
          if (!opt.value) return;
          const test = options.slice();
          test[idx] = opt.value;
          const match = this.variants.find((v) => v.available && v.options.every((o, i) => test[i] === null || o === test[i]));
          const base = opt.dataset.label || opt.value;
          opt.textContent = match ? base : `${base} (${F.strings.soldOut})`;
        });
      });
    }

    render(variant, options) {
      const p = this.product;
      const btns = $$('[data-add-button]', p.closest('.shopify-section') || p);
      const stickyBtn = $('[data-sticky-add]');
      const setButtons = (text, disabled) => {
        [...btns, stickyBtn].filter(Boolean).forEach((b) => {
          delete b.dataset.incomplete;
          const label = $('[data-add-label]', b) || b;
          label.textContent = text;
          b.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          if (b.type === 'submit') b.disabled = disabled;
        });
      };

      if (!variant) {
        setButtons(F.strings.unavailable, true);
        $$('[data-price-wrap]', p).forEach((el) => el.classList.add('is-unavailable'));
        return;
      }

      if (this.idInput) {
        this.idInput.value = variant.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      $$('input[name="id"]', p).forEach((i) => { if (i !== this.idInput) i.value = variant.id; });

      if (this.updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Fiyat
      $$('[data-price-wrap]', p).forEach((wrap) => {
        wrap.classList.remove('is-unavailable');
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const priceEl = $('[data-price]', wrap);
        const compareEl = $('[data-compare]', wrap);
        const saveEl = $('[data-save]', wrap);
        wrap.classList.toggle('price--sale', !!onSale);
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) { compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; compareEl.hidden = !onSale; }
        if (saveEl) {
          const pct = onSale ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
          saveEl.textContent = saveEl.dataset.mode === 'amount'
            ? F.strings.save.replace('[amount]', formatMoney(variant.compare_at_price - variant.price))
            : `%${pct}`;
          saveEl.hidden = !onSale;
        }
      });
      $$('[data-btn-price]').forEach((el) => { el.textContent = formatMoney(variant.price); });
      $$('[data-sticky-price]').forEach((el) => { el.textContent = formatMoney(variant.price); });
      $$('[data-sticky-variant]').forEach((el) => { el.textContent = variant.title; });

      // Ücretsiz kargo bayrağı
      const flag = $('[data-free-ship-flag]', p);
      if (flag && F.freeShippingThreshold > 0) flag.hidden = variant.price < F.freeShippingThreshold;

      // Stok
      const stock = $('[data-stock]', p);
      if (stock) {
        stock.classList.remove('stock--low', 'stock--out');
        if (!variant.available) { stock.classList.add('stock--out'); stock.textContent = stock.dataset.outText; }
        else if (variant.low && variant.qty > 0) { stock.classList.add('stock--low'); stock.textContent = stock.dataset.lowText.replace('[count]', variant.qty); }
        else stock.textContent = stock.dataset.inText;
        stock.hidden = false;
      }

      // SKU
      const sku = $('[data-sku]', p);
      if (sku) sku.textContent = variant.sku || '';

      setButtons(variant.available ? F.strings.addToCart : F.strings.soldOut, !variant.available);

      // Görsel
      if (variant.media_id) {
        const gallery = $('[data-gallery]', p);
        if (gallery && gallery.__gallery) gallery.__gallery.goToMedia(variant.media_id);
        $$('[data-variant-image]', p.closest('.shopify-section') || p).forEach((img) => {
          if (variant.image) { img.src = variant.image; img.removeAttribute('srcset'); }
        });
      }
      const stickyImg = $('[data-sticky-image]');
      if (stickyImg && variant.image) stickyImg.src = variant.image;

      // WhatsApp bağlantısı
      $$('[data-wa-link]', p).forEach((a) => {
        const base = a.dataset.waBase || '';
        a.href = base.replace('__VARIANT__', encodeURIComponent(variant.title));
      });

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, product: p, options } }));
    }

    selectValue(optionName, value) {
      const group = $$('[data-option-index]', this.root).find((g) => (g.dataset.optionName || '').toLowerCase() === optionName.toLowerCase());
      if (!group) return false;
      const radio = $$('input[type="radio"]', group).find((i) => i.value === value);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      const select = $('select', group);
      if (select && $$('option', select).some((o) => o.value === value)) {
        select.value = value; select.dispatchEvent(new Event('change', { bubbles: true })); return true;
      }
      return false;
    }
  }

  // Seçim tamamlanmadan sepete eklemeyi engelle (uygulamaların dinleyicilerinden önce çalışır)
  function guardIncomplete(e) {
    const trigger = e.type === 'submit' ? e.target.closest('form[data-product-form]') : e.target.closest('[data-add-button], [data-sticky-add]');
    if (!trigger) return;
    const scope = trigger.closest('[data-product]') || document.querySelector('[data-product]');
    const pickerEl = scope && $('[data-variant-picker]', scope);
    const picker = pickerEl && !pickerEl.closest('.is-app-hidden') && pickerEl.__picker;
    if (picker && picker.isIncomplete()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      picker.promptMissing();
    }
  }
  document.addEventListener('click', guardIncomplete, true);
  document.addEventListener('submit', guardIncomplete, true);

  function initVariantPickers(root = document) {
    $$('[data-variant-picker]', root).forEach((el) => {
      if (!el.__picker) el.__picker = new VariantPicker(el);
    });
  }

  /* ---------- Galeri ---------- */
  class Gallery {
    constructor(root) {
      this.root = root;
      this.track = $('[data-gallery-track]', root);
      this.slides = $$('[data-gallery-slide]', root);
      this.thumbs = $$('[data-gallery-thumb]', root);
      this.counter = $('[data-gallery-counter]', root);
      this.prev = $('[data-gallery-prev]', root);
      this.next = $('[data-gallery-next]', root);
      this.index = 0;
      if (!this.track) return;
      this.track.addEventListener('scroll', debounce(() => this.sync(), 60), { passive: true });
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i)));
      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
      $$('[data-zoom]', root).forEach((btn) => btn.addEventListener('click', () => this.openLightbox(btn)));
      $$('[data-video-play]', root).forEach((btn) => btn.addEventListener('click', () => {
        const video = $('video', btn.parentElement);
        if (video) { video.controls = true; video.play(); btn.remove(); }
      }));
      this.sync();
    }

    sync() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      this.setIndex(Math.max(0, Math.min(this.slides.length - 1, i)));
    }

    setIndex(i) {
      this.index = i;
      if (this.counter) this.counter.textContent = `${i + 1} / ${this.slides.length}`;
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      const thumb = this.thumbs[i];
      if (thumb && thumb.parentElement) {
        const strip = thumb.closest('[data-gallery-thumbs]');
        if (strip && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      this.slides.forEach((s, n) => {
        const v = $('video', s);
        if (v && n !== i && !v.paused) v.pause();
      });
    }

    goTo(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.setIndex(i);
    }

    goToMedia(id) {
      const i = this.slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
      if (i < 0) return;
      if (this.root.classList.contains('gallery--grid') && window.matchMedia('(min-width: 990px)').matches) {
        if (i > 0) {
          const slide = this.slides[i];
          this.track.prepend(slide);
          this.slides.splice(i, 1);
          this.slides.unshift(slide);
        }
        return;
      }
      this.goTo(i);
    }

    openLightbox(btn) {
      const src = btn.dataset.zoom;
      if (!src) return;
      const box = document.createElement('div');
      box.className = 'lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = `<img class="lightbox__img" src="${src}" alt=""><button type="button" class="close-btn" aria-label="Kapat"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
      const close = () => { box.remove(); document.documentElement.classList.remove('has-drawer'); btn.focus(); document.removeEventListener('keydown', onKey); };
      const onKey = (e) => { if (e.key === 'Escape') close(); };
      box.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(box);
      document.documentElement.classList.add('has-drawer');
      $('button', box).focus();
    }
  }

  function initGalleries(root = document) {
    $$('[data-gallery]', root).forEach((el) => { if (!el.__gallery) el.__gallery = new Gallery(el); });
  }

  /* ---------- Beden rehberi ---------- */
  function initSizeGuides(root = document) {
    $$('[data-size-finder]', root).forEach((finder) => {
      if (finder.__init) return;
      finder.__init = true;
      const typeSel = $('[data-finder-type]', finder);
      const sizeSel = $('[data-finder-size]', finder);
      const result = $('[data-finder-result]', finder);
      const resultValue = $('[data-finder-value]', finder);
      const applyBtn = $('[data-finder-apply]', finder);
      const table = $('[data-size-table]', finder.closest('.drawer__body') || document);
      const rows = table ? $$('tbody tr', table) : [];

      const fillSizes = () => {
        const col = typeSel.value === 'kumas' ? 1 : 0;
        const current = sizeSel.value;
        sizeSel.innerHTML = `<option value="">${sizeSel.dataset.placeholder}</option>` +
          rows.map((r, i) => `<option value="${i}">${r.cells[col].textContent.trim()}</option>`).join('');
        if (current) sizeSel.value = current;
      };

      const update = () => {
        rows.forEach((r) => r.classList.remove('is-match'));
        if (sizeSel.value === '') { result.hidden = true; return; }
        const row = rows[parseInt(sizeSel.value, 10)];
        if (!row) return;
        row.classList.add('is-match');
        const belt = row.cells[row.cells.length - 1].textContent.trim();
        resultValue.textContent = belt;
        result.hidden = false;
        applyBtn.dataset.value = belt;
        const picker = $('[data-variant-picker]');
        applyBtn.hidden = !((picker && picker.__picker && !picker.closest('.is-app-hidden')) || $('[data-bundle]'));
      };

      typeSel.addEventListener('change', () => { fillSizes(); update(); });
      sizeSel.addEventListener('change', update);
      applyBtn.addEventListener('click', () => {
        const bundle = $('[data-bundle]');
        if (bundle && bundle.__bundle) {
          const n = bundle.__bundle.tier();
          let applied = false;
          $$('[data-item]', bundle).slice(0, n).forEach((item) => {
            const sel = $('select[data-size]', item);
            if (sel && !sel.value) {
              const opt = $$('option', sel).find((o) => o.value === applyBtn.dataset.value && !o.disabled);
              if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); applied = true; }
            }
          });
          closeDrawer(finder.closest('.drawer'));
          if (applied) toast(`${applyBtn.dataset.value} ${applyBtn.dataset.selectedText || ''}`.trim());
          return;
        }
        const picker = $('[data-variant-picker]');
        if (!picker || !picker.__picker) return;
        const name = applyBtn.dataset.optionName || 'Beden';
        const ok = picker.__picker.selectValue(name, applyBtn.dataset.value);
        closeDrawer(finder.closest('.drawer'));
        if (ok) toast(`${applyBtn.dataset.value} ${applyBtn.dataset.selectedText || ''}`.trim());
      });
      fillSizes();
    });
  }

  /* ---------- Kargoya teslim tarihi ---------- */
  // Hafta sonu ve resmi tatiller sayılmaz. Tatiller: "10-29" (her yıl) veya "2027-03-10" (tek gün).
  function addBusinessDays(date, days, holidays = []) {
    const d = new Date(date);
    const isOff = (x) => {
      const day = x.getDay();
      if (day === 0 || day === 6) return true;
      const mm = String(x.getMonth() + 1).padStart(2, '0');
      const dd = String(x.getDate()).padStart(2, '0');
      return holidays.includes(`${mm}-${dd}`) || holidays.includes(`${x.getFullYear()}-${mm}-${dd}`);
    };
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isOff(d)) added++;
    }
    return d;
  }

  function initDelivery(root = document) {
    $$('[data-delivery]', root).forEach((el) => {
      const max = parseInt(el.dataset.max, 10) || 0;
      const holidays = (el.dataset.holidays || '').split(/[\s,]+/).map((h) => h.trim()).filter(Boolean);
      const months = (F.strings.months || '').split(',');
      const days = (F.strings.days || '').split(',');
      const shipBy = addBusinessDays(new Date(), max, holidays);
      const target = $('[data-ship-by]', el);
      if (target) target.textContent = `${shipBy.getDate()} ${months[shipBy.getMonth()] || ''} ${days[shipBy.getDay()] || ''}`.trim();
      el.hidden = false;
    });
  }

  /* ---------- Yapışkan satın alma çubuğu ---------- */
  function initStickyBuy() {
    const bar = $('[data-sticky-buy]');
    const anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    const footer = $('.footer');
    let anchorVisible = true;
    let footerVisible = false;
    let passed = false;
    const update = () => bar.classList.toggle('is-visible', !anchorVisible && passed && !footerVisible);
    new IntersectionObserver(([entry]) => {
      anchorVisible = entry.isIntersecting;
      passed = entry.boundingClientRect.top < 0;
      update();
    }).observe(anchor);
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; update(); }).observe(footer);
    const bundleBtn = $('[data-sticky-bundle]', bar);
    if (bundleBtn) bundleBtn.addEventListener('click', () => {
      const target = $('[data-bundle]') || $('kaching-bundle-deals, kaching-bundle, [class*="kaching-bundles"]') || anchor;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
    const btn = $('[data-sticky-add]', bar);
    if (btn) btn.addEventListener('click', () => {
      const form = $('form[data-product-form]');
      const picker = $('[data-variant-picker]');
      if (btn.getAttribute('aria-disabled') === 'true' || !form) {
        (picker || anchor).scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  /* ---------- Hızlı arama ---------- */
  function initPredictiveSearch() {
    $$('[data-predictive-search]').forEach((wrap) => {
      const input = $('input[type="search"]', wrap);
      const results = $('[data-predictive-results]', wrap);
      if (!input || !results) return;
      let controller;
      const run = debounce(async () => {
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${F.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
          const res = await fetch(url, { signal: controller.signal });
          if (!res.ok) return;
          const doc = parseHTML(await res.text());
          const content = $('[data-predictive-content]', doc);
          results.innerHTML = content ? content.innerHTML : '';
          results.hidden = false;
        } catch (_) { /* iptal */ }
      }, 220);
      input.addEventListener('input', run);
      input.addEventListener('keydown', (e) => {
        const items = $$('a.predictive__item', results);
        if (!items.length || !['ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault();
        const idx = items.findIndex((a) => a.getAttribute('aria-selected') === 'true');
        const next = e.key === 'ArrowDown' ? Math.min(items.length - 1, idx + 1) : Math.max(0, idx - 1);
        items.forEach((a, i) => a.setAttribute('aria-selected', i === next ? 'true' : 'false'));
        items[next].focus();
      });
    });
  }

  /* ---------- Koleksiyon: sıralama ve "daha fazla göster" ---------- */
  document.addEventListener('change', (e) => {
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    const url = btn.dataset.nextUrl;
    if (!url) return;
    btn.classList.add('is-loading');
    try {
      const sectionId = btn.dataset.sectionId;
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      const res = await fetch(fetchUrl.toString());
      const doc = parseHTML(await res.text());
      const grid = $('[data-product-list]');
      $$('[data-product-list] > li', doc).forEach((li) => grid.appendChild(li));
      const nextBtn = $('[data-load-more]', doc);
      const status = $('[data-load-status]', doc);
      const currentStatus = $('[data-load-status]');
      if (status && currentStatus) currentStatus.replaceWith(status);
      if (nextBtn && nextBtn.dataset.nextUrl) btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
      else btn.remove();
      const u = new URL(url, window.location.origin);
      window.history.replaceState({}, '', u.pathname + u.search);
    } catch (_) {
      window.location.href = url;
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- Delikli / deliksiz gösterimi ---------- */
  function initNotchDemo(root = document) {
    $$('[data-notch]', root).forEach((demo) => {
      if (demo.__init) return;
      demo.__init = true;
      const holes = parseInt(demo.dataset.holes, 10) || 5;
      const notches = parseInt(demo.dataset.notches, 10) || 40;
      const holeMarker = $('[data-hole-marker]', demo);
      const railMarker = $('[data-rail-marker]', demo);
      const holeOut = $('[data-hole-out]', demo);
      const railOut = $('[data-rail-out]', demo);
      // Fiziksel ölçü: delik aralığı yaklaşık 25 mm kabul edilir; ray tüm aralığı kademelere böler.
      const span = (holes - 1) * 25;
      let target = Math.round(notches * 0.55);
      const render = () => {
        const railPct = 6 + (target / notches) * 88;
        const mm = (target / notches) * span;
        const holeIndex = Math.round(mm / 25);
        const holePct = 12 + (holeIndex / (holes - 1)) * 72;
        railMarker.style.setProperty('--pos', `${railPct}%`);
        holeMarker.style.setProperty('--pos', `${holePct}%`);
        if (railOut) railOut.textContent = `${target}/${notches}`;
        if (holeOut) holeOut.textContent = `${holeIndex + 1}/${holes}`;
      };
      $$('[data-notch-step]', demo).forEach((b) => b.addEventListener('click', () => {
        target = Math.max(0, Math.min(notches, target + parseInt(b.dataset.notchStep, 10)));
        render();
      }));
      render();
      if (!reduceMotion && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          io.disconnect();
          let n = 0;
          const seq = [1, 1, 1, -1, 1];
          const tick = setInterval(() => {
            target = Math.max(0, Math.min(notches, target + seq[n]));
            render();
            if (++n >= seq.length) clearInterval(tick);
          }, 420);
        }, { threshold: 0.6 });
        io.observe(demo);
      }
    });
  }

  /* ---------- Video: görünür olduğunda yükle ---------- */
  function initLazyVideos(root = document) {
    const vids = $$('video[data-lazy-src]', root);
    if (!vids.length) return;
    const load = (v) => { v.src = v.dataset.lazySrc; v.removeAttribute('data-lazy-src'); if (v.autoplay && !reduceMotion) v.play().catch(() => {}); };
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { load(en.target); io.unobserve(en.target); }
    }), { rootMargin: '200px' });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------- Bağlantı: sayfa içi kaydırma (ürün seçimine dön) ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"][data-scroll-to]');
    if (!a) return;
    const target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Video penceresi ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-modal]');
    if (!btn) return;
    e.preventDefault();
    const modal = document.createElement('div');
    modal.className = 'video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', btn.getAttribute('aria-label') || '');
    modal.innerHTML = `<video src="${btn.dataset.videoModal}" playsinline autoplay muted loop controls></video><button type="button" class="close-btn" aria-label="Kapat"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
    const close = () => { modal.remove(); document.documentElement.classList.remove('has-drawer'); document.removeEventListener('keydown', onKey); btn.focus(); };
    const onKey = (ev) => { if (ev.key === 'Escape') close(); };
    modal.addEventListener('click', (ev) => { if (ev.target === modal || ev.target.closest('.close-btn')) close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(modal);
    document.documentElement.classList.add('has-drawer');
    $('.close-btn', modal).focus();
  });

  /* ---------- Kısaltma rehberi: video çekmece açılınca yüklenir ---------- */
  document.addEventListener('drawer:open', (e) => {
    const video = e.target.querySelector && e.target.querySelector('[data-shorten-video]');
    if (!video) return;
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      video.preload = 'auto';
    }
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  });
  document.addEventListener('drawer:close', (e) => {
    const video = e.target.querySelector && e.target.querySelector('[data-shorten-video]');
    if (video) video.pause();
  });

  /* ---------- Kart: renk kutucuğuyla görsel değiştir ---------- */
  ['mouseover', 'focusin'].forEach((type) => document.addEventListener(type, (e) => {
    const sw = e.target.closest('.card__swatch[data-img]');
    if (!sw) return;
    const img = $('.card__img-1', sw.closest('.card'));
    if (img && img.dataset.swap !== sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; img.dataset.swap = sw.dataset.img; }
  }));


  /* ---------- Paket ve ödeme seçici ---------- */
  const fmtTL = (cents) => {
    const v = Math.round(cents) / 100;
    const whole = Math.abs(v - Math.round(v)) < 0.005;
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v) + ' TL';
  };
  const roundHalfDownTL = (cents) => Math.ceil(cents / 100 - 0.5) * 100;

  class Bundle {
    constructor(root) {
      this.root = root;
      const json = $('script[data-bundle-variants]', root);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.unit = parseInt(root.dataset.unit, 10) || 0;
      this.pct2 = parseFloat(root.dataset.pct2) || 0;
      this.pct3 = parseFloat(root.dataset.pct3) || 0;
      this.giftMin = parseInt(root.dataset.giftMin, 10) || 99;
      this.giftVariant = root.dataset.giftVariant;
      this.codFee = parseInt(root.dataset.codFee, 10) || 0;
      this.threshold = parseInt(root.dataset.threshold, 10) || 0;
      this.shipFee = parseInt(root.dataset.shipFee, 10) || 0;
      this.cta = $('[data-bundle-cta]', root);
      this.summary = $('[data-summary]', root);
      $$('[data-money]', root).forEach((el) => { el.textContent = fmtTL(parseInt(el.dataset.money, 10)); });
      root.addEventListener('change', (e) => this.onChange(e));
      this.cta.addEventListener('click', () => this.submit(this.payment()));
      const addCart = $('[data-bundle-addcart]', root);
      if (addCart) addCart.addEventListener('click', () => this.submit('cart'));
      $$('[data-item]', root).forEach((item) => this.refreshItem(item));
      this.update();
    }

    tier() { const r = $('.tier__input:checked', this.root); return r ? parseInt(r.value, 10) : 1; }
    payment() { const r = $('[data-pay-opt] input:checked', this.root); return r ? r.value : null; }

    total(n = this.tier()) {
      let disc = 0;
      if (n >= 2) disc = roundHalfDownTL(this.unit * this.pct2 / 100);
      if (n >= 3) disc = roundHalfDownTL(this.unit * (this.pct2 + this.pct3) / 100);
      return this.unit * n - disc;
    }

    itemOptions(item) {
      return $$('[data-opt]', item).map((el) => {
        if (el.tagName === 'SELECT') return el.value || null;
        const r = $('input:checked', el);
        return r ? r.value : null;
      });
    }

    itemVariant(item) {
      const opts = this.itemOptions(item);
      if (opts.some((o) => o === null)) return null;
      return this.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }

    // Seçilen renge göre stokta olmayan bedenleri işaretle
    refreshItem(item) {
      const groups = $$('[data-opt]', item);
      const opts = this.itemOptions(item);
      groups.forEach((g, gi) => {
        if (g.tagName !== 'SELECT') {
          const label = $('[data-color-label]', item);
          if (label) label.textContent = opts[gi] ? `· ${opts[gi]}` : '';
          return;
        }
        $$('option', g).forEach((opt) => {
          if (!opt.value) return;
          const ok = this.variants.some((v) => v.available && v.options[gi] === opt.value &&
            v.options.every((o, i) => i === gi || opts[i] === null || groups[i].tagName === 'SELECT' || o === opts[i]));
          opt.disabled = !ok;
          opt.textContent = ok ? opt.value : `${opt.value} (${F.strings.soldOut})`;
          if (!ok && opt.selected) g.value = '';
        });
      });
    }

    onChange(e) {
      const t = e.target;
      if (t.classList.contains('tier__input')) {
        const n = this.tier();
        $$('.tier', this.root).forEach((l) => l.classList.toggle('is-active', parseInt(l.dataset.tier, 10) === n));
        $$('[data-item]', this.root).forEach((item) => { item.hidden = parseInt(item.dataset.item, 10) > n; });
      }
      const item = t.closest('[data-item]');
      if (item) {
        this.refreshItem(item);
        const err = $('[data-item-error]', item);
        if (err && this.itemVariant(item)) err.hidden = true;
        item.classList.remove('is-invalid');
        // İlk kemerin rengi değişince galeriyi o renge götür
        if (item.dataset.item === '1' && t.type === 'radio') {
          const opts = this.itemOptions(item);
          const gi = $$('[data-opt]', item).findIndex((g) => g.contains(t));
          const v = this.variants.find((x) => x.options[gi] === opts[gi] && x.media);
          const gallery = $('[data-gallery]');
          if (v && gallery && gallery.__gallery) gallery.__gallery.goToMedia(v.media);
        }
      }
      if (t.closest('[data-pay-opt]')) {
        $$('[data-pay-opt]', this.root).forEach((o) => o.classList.toggle('is-active', $('input', o).checked));
        const perr = $('[data-pay-error]', this.root);
        if (perr) perr.hidden = true;
        this.root.querySelector('[data-paym]').classList.remove('is-invalid');
      }
      this.update();
    }

    update() {
      const n = this.tier();
      const total = this.total(n);
      const pay = this.payment();
      const cardShip = this.threshold && total >= this.threshold ? 0 : this.shipFee;
      const cardTag = $('[data-card-tag]', this.root);
      if (cardTag) cardTag.textContent = cardShip === 0 ? F.strings.freeShipping : `+${fmtTL(cardShip)} ${F.strings.shippingWord}`;
      const label = $('[data-cta-label]', this.cta);
      const price = $('[data-cta-price]', this.cta);
      const available = this.variants.some((v) => v.available);
      if (!available) { label.textContent = this.cta.dataset.labelSoldout; price.textContent = ''; this.cta.disabled = true; return; }
      let pay_total = total;
      if (pay === 'card') { label.textContent = this.cta.dataset.labelCard; pay_total = total + cardShip; }
      else if (pay === 'cod') { label.textContent = this.cta.dataset.labelCod; pay_total = total + this.codFee; }
      else label.textContent = this.cta.dataset.labelNone;
      price.textContent = fmtTL(pay_total);
      this.cta.dataset.pay = pay || '';
      if (this.summary) {
        const parts = [`${F.strings.bundleTotal}: <strong>${fmtTL(total)}</strong>`];
        if (pay === 'cod' && this.codFee) parts.push(`${F.strings.codFee}: +${fmtTL(this.codFee)}`);
        if (pay === 'card') parts.push(cardShip ? `${F.strings.shippingWord}: +${fmtTL(cardShip)}` : F.strings.freeShipping);
        if (n >= this.giftMin && this.giftVariant) parts.push(F.strings.giftIncluded);
        this.summary.innerHTML = parts.join(' · ');
      }
    }

    validate(needPayment) {
      const n = this.tier();
      let firstBad = null;
      $$('[data-item]', this.root).slice(0, n).forEach((item) => {
        const v = this.itemVariant(item);
        const err = $('[data-item-error]', item);
        if (!v || !v.available) {
          const missing = $$('select[data-opt]', item).find((sel) => !sel.value);
          err.textContent = missing
            ? F.strings.bundleChoose.replace('[item]', item.dataset.item).replace('[option]', ($('label', missing.parentElement) || {}).textContent || '')
            : F.strings.unavailable;
          err.hidden = false;
          item.classList.add('is-invalid');
          if (!firstBad) firstBad = missing || item;
        }
      });
      if (!firstBad && needPayment && !this.payment()) {
        const paym = $('[data-paym]', this.root);
        paym.classList.add('is-invalid');
        $('[data-pay-error]', this.root).hidden = false;
        firstBad = paym;
      }
      if (firstBad) {
        firstBad.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        if (firstBad.focus) setTimeout(() => firstBad.focus({ preventScroll: true }), 300);
        return false;
      }
      return true;
    }

    // Bu ürünün paketi sepette tek kayıt olarak tutulur: yeniden eklenince eskisi silinir
    token() {
      if (this._token) return this._token;
      const key = `ferlant-set-${this.root.dataset.productId || ''}`;
      let t = null;
      try { t = sessionStorage.getItem(key); } catch (e) { /* gizli sekme */ }
      if (!t) {
        t = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
        try { sessionStorage.setItem(key, t); } catch (e) { /* yoksay */ }
      }
      this._token = t;
      return t;
    }

    async removePrevious() {
      const token = this.token();
      const res = await fetch(`${F.routes.cart}.js`, { headers: { Accept: 'application/json', 'X-Ferlant': '1' } });
      if (!res.ok) return;
      const cart = await res.json();
      // Bu ürünün sepetteki tüm satırları ve paketle gelen hediye toka silinir; yerine yeni seçim eklenir.
      // Böylece kapıda ödemeden vazgeçip kartla devam eden müşteri sepette iki paket görmez.
      const ownIds = new Set(this.variants.map((v) => v.id));
      const giftId = parseInt(this.giftVariant, 10);
      const updates = {};
      let legacy = false;
      (cart.items || []).forEach((line) => {
        const tagged = line.properties && line.properties._set;
        if (ownIds.has(line.variant_id) || tagged === token || (line.variant_id === giftId && tagged)) {
          updates[line.key] = 0;
          if (!tagged) legacy = true;
        }
      });
      // Eski sürümden kalan etiketsiz paketin hediye tokası
      if (legacy) (cart.items || []).forEach((line) => {
        if (line.variant_id === giftId && !(line.properties && line.properties._set) && line.quantity === 1) updates[line.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      await fetch(`${F.routes.cartUpdate}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Ferlant': '1' },
        body: JSON.stringify({ updates })
      });
    }

    items() {
      const n = this.tier();
      const props = { _set: this.token() };
      const map = new Map();
      $$('[data-item]', this.root).slice(0, n).forEach((item) => {
        const v = this.itemVariant(item);
        map.set(v.id, (map.get(v.id) || 0) + 1);
      });
      const items = [...map].map(([id, quantity]) => ({ id, quantity, properties: props }));
      if (n >= this.giftMin && this.giftVariant) items.push({ id: parseInt(this.giftVariant, 10), quantity: 1, properties: props });
      return items;
    }

    async submit(mode) {
      if (!this.validate(mode !== 'cart')) return;
      const btn = mode === 'cart' ? $('[data-bundle-addcart]', this.root) : this.cta;
      if (btn.classList.contains('is-loading')) return;
      try {
        btn.classList.add('is-loading');
        try { await this.removePrevious(); } catch (e) { /* sepet okunamadıysa yine de ekle */ }
        btn.classList.remove('is-loading');
        if (mode === 'card') {
          await Cart.add(this.items(), { open: false, button: btn });
          window.location.href = (F.routes.root || '/').replace(/\/?$/, '/') + 'checkout';
        } else if (mode === 'cod') {
          await Cart.add(this.items(), { open: true, button: btn });
          openCodForm();
        } else {
          await Cart.add(this.items(), { open: true, button: btn });
        }
      } catch (err) {
        btn.classList.remove('is-loading');
        toast(err.message || F.strings.cartError);
      }
    }
  }

  // Kapıda ödeme: EasySell formunu sepet modunda aç (çekmecedeki/sepet sayfasındaki EasySell butonu)
  function findCodButton() {
    const scopes = [$('#CartDrawer'), $('[data-cart-page]'), document];
    for (const scope of scopes) {
      if (!scope) continue;
      const btn = $$('[class*="es-popup-button"], [class*="es-cart-button"], [data-es-button]', scope)
        .find((b) => !b.closest('[data-bundle]') && !b.classList.contains('es-popup-button-product') && b.offsetParent !== null);
      if (btn) return btn;
    }
    return null;
  }
  function openCodForm(tries = 0) {
    const btn = findCodButton();
    if (btn) { btn.click(); return; }
    if (tries < 12) { setTimeout(() => openCodForm(tries + 1), 250); return; }
    // EasySell çekmecede bulunamadı: sepet sayfasına git, orada tekrar denenir
    if (!$('[data-cart-page]')) window.location.href = `${F.routes.cart}?odeme=kapida`;
    else toast(F.strings.codFallback);
  }
  F.openCodForm = openCodForm;

  function initBundles(root = document) {
    $$('[data-bundle]', root).forEach((el) => { if (!el.__bundle) el.__bundle = new Bundle(el); });
    if ($('[data-cart-page]') && /[?&]odeme=kapida/.test(window.location.search)) setTimeout(() => openCodForm(), 600);
  }

  /* ---------- Başlat ---------- */
  function init(root = document) {
    initVariantPickers(root);
    initBundles(root);
    initGalleries(root);
    initSizeGuides(root);
    initDelivery(root);
    initNotchDemo(root);
    initLazyVideos(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    initStickyBuy();
    initPredictiveSearch();
  });

  // Tema düzenleyici
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const drawer = e.target.closest('.drawer');
    if (drawer) openDrawer(drawer.id);
  });
})();
